import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { tokens } from '../../design-system/tokens';
import { DOC_CATALOG } from './docCatalog';
import { getDocMarkdown } from './docBundle';
import { markdownToSafeHtml, rewriteDocMarkdownLinks } from './markdownRender';
import { AppVersionLabel } from '../../components/AppVersionLabel';

type Props = { variant: 'public' | 'console' };

export function DocsHub({ variant }: Props) {
  const base = variant === 'console' ? '/app/docs' : '/docs';
  const readme = getDocMarkdown('README');
  const introHtml = useMemo(() => {
    if (!readme) return '';
    const mode = variant === 'console' ? 'app' : 'public';
    const raw = rewriteDocMarkdownLinks(readme, 'consola', mode);
    return markdownToSafeHtml(raw);
  }, [readme, variant]);

  return (
    <div>
      <h1 style={{ margin: '0 0 8px', fontSize: 26, fontWeight: 800, color: tokens.semantic.textPrimary }}>Centro de ayuda</h1>
      <p style={{ margin: '0 0 12px', fontSize: 15, color: tokens.semantic.textSecondary, maxWidth: 640 }}>
        Guías por módulo, con el mismo criterio visual que la consola. Usá el buscador del panel izquierdo para saltar a un tema.
      </p>
      <p style={{ margin: '0 0 20px' }}>
        <AppVersionLabel title="Versión de la consola y documentación" />
        <span style={{ marginLeft: 8, fontSize: 13, color: tokens.semantic.textMuted }}>
          — ver también{' '}
          <Link to={`${base}/consola/version`} style={{ color: tokens.colors.accent[600], fontWeight: 600 }}>
            Versión y despliegue
          </Link>
        </span>
      </p>
      {introHtml ? (
        <div className="va-doc-article" style={{ marginBottom: 28 }} dangerouslySetInnerHTML={{ __html: introHtml }} />
      ) : null}
      <div style={{ fontSize: 13, fontWeight: 700, color: tokens.semantic.textMuted, marginBottom: 10 }}>Artículos ({DOC_CATALOG.length})</div>
      <ul style={{ margin: 0, padding: 0, listStyle: 'none', display: 'grid', gap: 10, gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))' }}>
        {DOC_CATALOG.map((d) => (
          <li key={`${d.area}/${d.slug}`}>
            <Link
              to={`${base}/${d.area}/${d.slug}`}
              style={{
                display: 'block',
                padding: '14px 16px',
                borderRadius: 12,
                border: `1px solid ${tokens.semantic.border}`,
                background: tokens.semantic.surfaceMuted,
                textDecoration: 'none',
                color: tokens.semantic.textPrimary,
                fontWeight: 600,
                fontSize: 14,
                transition: 'border-color 0.15s, box-shadow 0.15s',
              }}
            >
              {d.label}
              <div style={{ fontSize: 12, fontWeight: 500, color: tokens.semantic.textMuted, marginTop: 6 }}>{d.section}</div>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
